export const routes = {
  HomePage: '/',
  CalendarPage: '/calendar',
}
